var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "18px",
    viewBox: "0 0 21 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "96F4E43F-4989-4CA2-89B0-5A964E48B930") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-435.000000, -196.000000)",
    fill: "#E71037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(306.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "blind",
    transform: "translate(129.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2843033,2 C8.77977684,2 7.33824688,2.31697281 6,2.84717662 L7.02023145,3.79552862 C8.05403437,3.44739712 9.14997822,3.24508251 10.2843033,3.24508251 C14.4269811,3.24508251 18.1504604,5.73832001 19.6201055,9.47060347 C19.0600981,10.8929146 18.1694371,12.1314183 17.0562665,13.124448 L17.9981801,14 C19.3053565,12.8284766 20.3425037,11.3628252 20.9641853,9.67183368 C21.0119382,9.54112622 21.0119382,9.40008073 20.9641853,9.26937327 C19.3656698,4.92125382 15.0738225,2 10.2843033,2 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6546316,8.80305949 L13.8515721,10 C13.938656,9.67305025 14,9.3359664 14,8.98185111 C14,6.78614365 12.2138949,5 10.0181489,5 C9.6640336,5 9.32694975,5.06134402 9,5.14842787 L10.1969405,6.34536837 C11.5161067,6.43511097 12.564889,7.48389334 12.6546316,8.80305949 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.26654409,0.909070173 L3.83467717,3.51579297 C2.13380429,4.8214499 0.768340172,6.61062541 0.0338681582,8.7922072 C-0.0112893861,8.92717734 -0.0112893861,9.07282266 0.0338681582,9.2077928 C1.54546915,13.6977522 5.60402183,16.714275 10.133272,16.714275 C12.0160622,16.714275 13.794306,16.1527082 15.3630158,15.217398 L18.1044244,18 L19,17.0909672 L2.16208291,0 L1.26650732,0.909032847 L1.26654409,0.909070173 Z M10.1333088,15.4285874 C6.21578153,15.4285874 2.69466981,12.8540395 1.30489858,9.00003733 C1.99035186,7.09899635 3.22214523,5.5526999 4.73871061,4.43341075 L7.04251761,6.7718356 C6.59976775,7.40252986 6.33327204,8.16834356 6.33327204,9 C6.33327204,11.1269368 8.03782225,12.8571375 10.1333088,12.8571375 C10.9526535,12.8571375 11.7071301,12.5866374 12.3284877,12.1372346 L14.4361462,14.2765635 C13.1280483,14.9960559 11.6710556,15.4285874 10.1333088,15.4285874 Z M7.95883332,7.70195753 L11.4122087,11.2072246 C11.0353933,11.4330831 10.6017632,11.5714872 10.1333088,11.5714872 C8.73610939,11.5714872 7.59996323,10.4182316 7.59996323,9.00007465 C7.59996323,8.52458112 7.73631842,8.08443514 7.95883332,7.70195753 Z",
    id: "Shape",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlind);
export default __webpack_public_path__ + "static/media/blind.a547ddcfe768f7d1789afe7ba39be7f1.svg";
export { ForwardRef as ReactComponent };